import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomContractIdInput')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomContractIdInput = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      {/* @ts-expect-error@2322 */}
      <IForm
        className={styles.form}
        onChange={viewModel.handleFormChange}
        // @ts-expect-error@2339
        onValid={viewModel.handleFormValid}
      >
        <TextField
          // @ts-expect-error@2322
          label={tp('customer-number')}
          optional
          property='customerNumber'
        />
      </IForm>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2339
      extraButtons={viewModel.buttons}
      // @ts-expect-error@2339
      nextEnabled={viewModel.isValid}
      onBack={viewModel.handleBack}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomContractIdInput)
component.displayName = 'CustomContractIdInput'
export default component
